const key = 'uogorod-guide-history-v1';
export function readHistory(storage, guides) {
  try {
    const value = JSON.parse(storage.getItem(key) || '[]');
    if (!Array.isArray(value)) return [];
    return value.filter((entry, i, list) => entry && typeof entry.slug === 'string' &&
      list.findIndex(e => e?.slug === entry.slug) === i &&
      guides.some(g => g.slug === entry.slug && g.phases.some(p => p.urlId === entry.phase)))
      .slice(0, 6);
  } catch { return []; }
}
export function rememberGuide(storage, guides, slug, phase) {
  if (!guides.some(g => g.slug === slug && g.phases.some(p => p.urlId === phase))) return;
  try {
    storage.setItem(key, JSON.stringify([{slug, phase}, ...readHistory(storage, guides).filter(e => e.slug !== slug)].slice(0, 6)));
  } catch { /* Browsing remains available when storage is disabled. */ }
}
export function clearHistory(storage) {
  try { storage.removeItem(key); } catch { /* No persistent storage. */ }
}
